import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { LicenseSeatsManagementComponent } from './license-seats-management.component';


export { LicenseSeatsManagementModule } from './license-seats-management.module';
export const ngxLicenseSeatsManagementModule = angular.module('ngxLicenseSeatsManagementModule', [])
	.directive('ngxLicenseSeatsManagement', downgradeComponent({component: LicenseSeatsManagementComponent})).name;
